// Notification System Module
// Handles displaying toast notifications and overlays

(function() {
    'use strict';

    class NotificationManager {
        constructor() {
            this.container = null;
            this.init();
        }

        init() {
            // Create container if it doesn't exist
            if (!document.querySelector('.saborlista-notifications-container')) {
                this.container = document.createElement('div');
                this.container.className = 'saborlista-notifications-container';
                document.body.appendChild(this.container);
            } else {
                this.container = document.querySelector('.saborlista-notifications-container');
            }
        }

        /**
         * Show a notification
         * @param {string} message - The message to display
         * @param {string} type - 'error', 'success', 'info', 'warning'
         * @param {number} duration - Time in ms before auto-close (default 6000)
         */
        show(message, type = 'info', duration = 6000) {
            const toast = document.createElement('div');
            toast.className = `saborlista-toast type-${type}`;
            
            // Icon selection
            let iconClass = 'sb-edit';
            switch(type) {
                case 'success': iconClass = 'sb-check'; break;
                case 'error': iconClass = 'sb-ban'; break;
                case 'warning': iconClass = 'sb-alert'; break;
            }

            const closeLabel = (window.saborlistaAjax && window.saborlistaAjax.i18n && window.saborlistaAjax.i18n.close) || 'Close';
            toast.innerHTML = `
                <div class="toast-content">
                    <i class="sb ${iconClass}"></i>
                    <span class="message">${message}</span>
                </div>
                <button class="toast-close" aria-label="${closeLabel}">&times;</button>
            `;

            // Close button event
            toast.querySelector('.toast-close').addEventListener('click', () => {
                this.remove(toast);
            });

            // Append to container
            this.container.appendChild(toast);

            // Animate in
            requestAnimationFrame(() => {
                toast.classList.add('is-visible');
            });

            // Auto remove
            if (duration > 0) {
                setTimeout(() => {
                    this.remove(toast);
                }, duration);
            }
        }

        /**
         * Remove a toast with animation
         * @param {HTMLElement} toast 
         */
        remove(toast) {
            toast.classList.remove('is-visible');
            toast.addEventListener('transitionend', () => {
                if (toast.parentElement) {
                    toast.remove();
                }
            });
        }

        // Shortcuts
        error(message, duration = 8000) {
            this.show(message, 'error', duration);
        }

        success(message, duration = 6000) {
            this.show(message, 'success', duration);
        }

        info(message, duration = 6000) {
            this.show(message, 'info', duration);
        }
    }

    // Expose to global scope
    window.SaborlistaNotifications = new NotificationManager();

})();
